import type { Api } from '../api';
import type { MotornetVehicleKind } from '../motornet/types';

export const resolveMotornetImages = async (
	apiClient: Api,
	vehicleCode?: string | null,
	vehicleKind?: string | null
): Promise<{ url: string }[]> => {
	if (!vehicleCode) {
		return [];
	}

	try {
		const payload =
			await apiClient.motornetControllerService.getMotornetVehicle(
				vehicleCode,
				(vehicleKind as MotornetVehicleKind) ?? undefined
			);

		return (payload?.images ?? [])
			.filter((image) => image?.url)
			.map((image) => ({ url: image.url }));
	} catch (e) {
		console.warn('Could not resolve Motornet images for', vehicleCode, e);
		return [];
	}
};
